<template>
  <div class="mainmain" :id="'mainitem'+job.id">
    <div class="jobitemain" :id="'jobitem'+job.id">
      <a href="javascript:void(0);">
        <div class="itemtitle" :class="!show? 'titleitem':'titleitem1'" @click="onClick">
          <b>{{job.position}}</b>
        </div>
      </a>
      <div class="righticon">
        <a href="javascript:void(0);">
          <span class="zyjm-jiantou9" :class="show? 'icon':'icon1'" @click="onClick"></span>
        </a>
      </div>
      <div class="jobdetail" id="jobdetail">
        <div class="detailscroll">
          <!-- <div class="detailtitle">{{job.biaoti}}</div> -->
          <div class="detailjobtitle">职位信息</div>
          <div class="content" v-html="job.duty"></div>
          <div class="detailjobtitle" style="margin-top:0.56rem">任职要求</div>
          <div class="content" v-html="job.require"></div>
          <!-- <a href="javascript:void(0);">
            <div class="detailbtn" @click="onInterest">感兴趣</div>
          </a>-->
          <!-- <div class="more">
            <div class="moreimg">
              <a href="javascript:void(0);">
                <img
                  src="/static/按钮 副本_slices/未选中@2x(2).png"
                  @click="onInterest"
                  class="defaultimg"
                  :id="'defaultimg'+job.id"
                />
                <img
                  src="/static/按钮 副本_slices/组 3@2x(6).png"
                  @click="onInterest"
                  class="hoverimg"
                  :id="'hoverimg'+job.id"
                />
                <img
                  src="/static/按钮 副本_slices/组 3@2x(13).png"
                  @click="onInterest"
                  class="clickimg"
                  :id="'clickimg'+job.id"
                />
              </a>
            </div>
          </div>-->

          <!-- <div class="jobinput" v-if="isInteresting">
            <div class="jobitemdetail">
              <div class="detailtitle">我申请的职位是</div>
              <div class="detailjob">{{jobdetail.position}}</div>
            </div>
            <inputItem title="我是" placeholder="请输入" @input="onInput($event,'nametwo')" class="animated fadeInUp"></inputItem>
            <inputItem
              title="我的联系方式"
              @blur="onBlurPhonet"
              placeholder="请输入"
              @input="onInput($event,'phonetwo')"
              class="animated fadeInUp"
            ></inputItem>
            <div class="errmessage twopos" v-if="errphone">手机号格式错误</div>

            <inputItem
              title="我的邮箱"
              @blur="onBlurEmailt"
              placeholder="请输入"
              @input="onInput($event,'emailtwo')"
              class="animated fadeInUp"
            ></inputItem>
            <div class="errmessage thresspos" v-if="errmail">邮箱格式错误</div>

            <div class="textarea">
              <div class="areatitle">
                <b>简短介绍一下自己</b>
              </div>
              <textarea
                style="border: none;border: 2px solid black;width: 100%;height:2.5rem;padding:0.2rem"
                v-model="detailtwo"
                placeholder="请输入"
              ></textarea>
            </div>
            <div class="moretwo">
              <div class="moreimgtwo">
                <a href="javascript:void(0);">
                  <img src="/static/按钮 副本_slices/组 3@2x.png" @click="onJoin" class="defaultimgtwo" />
                  <img src="/static/按钮 副本_slices/组 3@2x(7).png" @click="onJoin" class="hoverimgtwo" />
                </a>
              </div>
            </div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import inputItem from '../components/input-item';
import BScroll from 'better-scroll'
export default {
  components: {
    inputItem
  },
  name: "job",
  props: {
    job: {
      type: Object,
    }
  },
  data() {
    return {
      show: false,
      isInteresting: false,
      jobdetail: "",
      nametwo: "",
      phonetwo: "",
      emailtwo: "",
      detailtwo: "",
      isOk: 0,
      noMore: 1,
      errphone: false,
      errmail: false,
      isSmall: false
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.$e.$on("smallWindow", () => {
        this.isSmall = true
      })
      this.$e.$on("bigWindow", () => {
        this.isSmall = false
      })
    })
  },
  methods: {

    onClick() {
      console.log('<<<<<<<<<<<<<<');
      this.show = !this.show;
      if (this.show) {
        $('#jobitem' + this.job.id).animate({ height: "940px" }, 500);
        $('#jobitem' + this.job.id).addClass('itemred');
        $('#mainitem' + this.job.id).removeClass('mainmain');

      } else {
        console.log(this.isSmall);
        if (this.isSmall) {
          $('#jobitem' + this.job.id).animate({ height: "100px" }, 500);
        } else {
          $('#jobitem' + this.job.id).animate({ height: "70px" }, 500);
        }

        $('#jobitem' + this.job.id).removeClass('itemred');
        $('#mainitem' + this.job.id).addClass('mainmain');
        this.isInteresting = false

      }
    },
    // onInterest() {
    //   this.isInteresting = true
    //   setTimeout(() => {
    //     $(`#jobitem${this.job.id} .jobdetail`).animate({ scrollTop: $(".jobinput").offset().top }, 1000)
    //   }, 100);
    //   $('#defaultimg' + this.job.id).css("display", "none");
    //   $('#hoverimg' + this.job.id).css("display", "none");
    //   $('#clickimg' + this.job.id).css("display", "block");

    // },
    /**
    * 数据加载
    */
    loadData() {
      console.log('>>>>>>>>>>>>>>');
      // this.$axios.post(this.$url.positionDetail, { id: this.job.id })
      //   .then(res => {
      //     // console.log(res.data);
      //     let { error_code, position } = res.data;
      //     if (error_code == 2001) {
      //       this.jobdetail = position
      //     }
      //   })
    },
    // onJoin() {
    //   let { nametwo, phonetwo, emailtwo, detailtwo, isOk, noMore } = this;
    //   let name = nametwo;
    //   let tel = phonetwo;
    //   let email = emailtwo;
    //   let inf = detailtwo;
    //   if (noMore == 2) {
    //     return
    //   }
    //   if (!name) {
    //     this.err1();
    //     this.noMore = 2
    //     setTimeout(() => {
    //       this.noMore = 1
    //     }, 2000);
    //     return
    //   } else if (!tel) {
    //     this.err5();
    //     this.noMore = 2
    //     setTimeout(() => {
    //       this.noMore = 1
    //     }, 2000);
    //     return
    //   } else if (!inf) {
    //     this.err6();
    //     this.noMore = 2
    //     setTimeout(() => {
    //       this.noMore = 1
    //     }, 2000);
    //     return
    //   } else if (!(/^((13[0-9])|(14[5,7,9])|(15[^4])|(18[0-9])|(17[0,1,3,5,6,7,8]))\d{8}$/.test(phonetwo))) {
    //     this.err2();
    //     this.noMore = 2
    //     setTimeout(() => {
    //       this.noMore = 1
    //     }, 2000);
    //     return
    //   } else if (emailtwo) {
    //     if (!(/^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/.test(emailtwo))) {
    //       this.err4();
    //       this.noMore = 2
    //       setTimeout(() => {
    //         this.noMore = 1
    //       }, 2000);
    //       return
    //     }
    //   }
    //   this.$axios.post(this.$url.position, { name, tel, email, inf, position: this.jobdetail.position })
    //     .then(res => {
    //       // console.log(res.data);
    //       let { error_code } = res.data;
    //       if (error_code == 2001) {
    //         this.success()
    //       }
    //     })
    // },
    // err1() {
    //   this.$message({
    //     message: '请填写您的姓名',
    //     type: 'error',
    //     iconClass: "__",
    //     customClass: "el-message--error"
    //   });
    // },
    // err5() {
    //   this.$message({
    //     message: '请填写您的手机号',
    //     type: 'error',
    //     iconClass: "__",
    //     customClass: "el-message--error"
    //   });
    // },
    // err6() {
    //   this.$message({
    //     message: '请填写您的介绍',
    //     type: 'error',
    //     iconClass: "__",
    //     customClass: "el-message--error"
    //   });
    // },
    // err7() {
    //   // this.$message.error('必填参数为空');
    //   this.$message({
    //     message: '请先填写信息',
    //     type: 'error',
    //     iconClass: "__",
    //     customClass: "el-message--error"
    //   });
    // },
    // err2() {
    //   // this.$message({
    //   //   message: '手机号格式错误',
    //   //   type: 'error',
    //   //   iconClass: "__",
    //   //   customClass: "el-message--error"
    //   // });
    //   this.errphone = true
    //   setTimeout(() => {
    //     this.errphone = false
    //   }, 2000);
    // },
    // success() {
    //   this.$message({
    //     message: '提交成功',
    //     type: 'success',
    //     iconClass: "__",
    //     customClass: "el-message--success"
    //   });
    // },
    // err4() {
    //   // this.$message.error('必填参数为空');
    //   // this.$message({
    //   //   message: '邮箱格式错误',
    //   //   type: 'error',
    //   //   iconClass: "__",
    //   //   customClass: "el-message--error"
    //   // });
    //   this.errmail = true
    //   setTimeout(() => {
    //     this.errmail = false
    //   }, 2000);
    // },
    // /**
    // * 输入
    // */
    // onInput(e, id) {
    //   this[id] = e
    // },
    // onBlurPhonet() {
    //   let { phonetwo, isOk } = this;
    //   if (!phonetwo) {
    //     return
    //   }
    //   if (isOk == 2) {
    //     return
    //   }
    //   if (!(/^((13[0-9])|(14[5,7,9])|(15[^4])|(18[0-9])|(17[0,1,3,5,6,7,8]))\d{8}$/.test(phonetwo))) {
    //     this.err2();
    //     this.isOk = 2
    //     setTimeout(() => {
    //       this.isOk = 1
    //     }, 2000);
    //   } else {
    //     this.isOk = 1
    //   }
    // },
    // onBlurEmailt() {
    //   let { emailtwo, isOk } = this
    //   if (!emailtwo) {
    //     return
    //   }
    //   if (isOk == 2) {
    //     return
    //   }
    //   if (!(/^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/.test(emailtwo))) {
    //     this.err4();
    //     this.isOk = 2
    //     setTimeout(() => {
    //       this.isOk = 1
    //     }, 2000);
    //   } else {
    //     this.isOk = 1
    //   }
    // }
  }
}
</script>

<style scoped>
.titleitem {
  color: black;
  transition: all 500ms;
}
.titleitem1 {
  color: #ff6900;
  transition: all 500ms;
}
.icon {
  transform: rotateZ(180deg);
  transition: all 500ms;
}
.icon1 {
  transform: rotateZ(0deg);
  transition: all 500ms;
}
.jobitemain {
  width: 100%;
  height: 70px;
  border: 2px solid black;
  margin-bottom: 0.4rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  position: relative;
  display: inline-block;
  transform: rotateZ(0deg);
  transition: all 500ms;
  overflow: hidden;
  display: block;
  background-color: transparent;
}
.mainmain {
  background-color: #fff;
}
.mainmain :hover {
  background-color: #eeeeee;
}
.itemtitle {
  line-height: 0.7rem;
  font-size: 0.26rem;
  /* margin-left: 0.5rem; */
}
.righticon {
  position: absolute;
  right: 19px;
  top: 19px;
  width: 32px;
  height: 32px;
  line-height: 32px;
  display: block;
  font-size: 32px;
}

.detailjobtitle {
  font-size: 0.22rem;
  width: 100%;
  margin-bottom: 0.2rem;
  /* color: #6c6c6c; */
  font-weight: 600;
}

.content p {
  font-size: 0.8rem;
  width: 100%;
  margin-bottom: 0.5rem;
  color: #6c6c6c;
}

.detailbtn {
  width: 1.9rem;
  height: 0.87rem;
  padding: 0.07rem 0.07rem 0 0;
  text-align: center;
  line-height: 0.79rem;
  font-size: 0.225rem;
  color: #ff6900;
  background: #fff url(/static/contact/按钮.png) center center no-repeat;
  background-size: cover;
  margin-bottom: 0.6rem;
  margin-top: 0.56rem;
}
.itemred {
  border: 2px solid #ff6900;
  box-shadow: 0px 17px 90px 0px rgba(216, 40, 46, 0.18);
}

.detailscroll {
  width: 100%;
  padding-bottom: 0.7rem;
  padding-top: 0.4rem;
}

.jobdetail {
  width: 100%;
  /* max-width: 45%;
  flex: 0 0 45%; */
  height: 9rem;
  font-size: 0.225rem;
  margin-bottom: 0.8rem;
  overflow: hidden;
  overflow-y: scroll;
}

.jobdetail::-webkit-scrollbar {
  display: none;
}
.detailtitle {
  margin-bottom: 0.15rem;
  font-weight: 600;
}
.detailjob {
  width: 100%;
  border-bottom: 2px solid black;
}
.threebottom {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
}

.comfirebtn {
  width: 208px;
  height: 79px;
  padding: 7px 7px 0 0;
  text-align: center;
  line-height: 0.79rem;
  font-size: 0.225rem;
  color: #ff6900;
  background: #fff url(/static/contact/comfire.png) center center no-repeat;
  background-size: cover;
  /* margin-top: 0.56rem; */
}

.jobitemdetail {
  width: 100%;
  max-width: 45%;
  flex: 0 0 45%;
  margin-bottom: 0.8rem;
}

.textarea {
  width: 100%;
  font-size: 0.225rem;
  margin-bottom: 0.4rem;
}

.jobinput {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  position: relative;
}

.errmessage {
  position: absolute;
  font-size: 0.225rem;
  color: red;
}
.twopos {
  top: 32%;
}

.thresspos {
  left: 55%;
  top: 32%;
}
textarea:focus {
  outline: medium;
}
.detailtop {
  height: 2.6rem;
}
.detailtoptop {
  height: 2.6rem;
  background-color: blue;
}

.more {
  /* width: 100%; */
  margin-bottom: 0.8rem;
  margin-top: 0.56rem;
  height: 0.8rem;
}
.moreimg img {
  height: 0.86rem;
}
.moreimg {
  width: 2.4rem;
  height: 0.86rem;
}
.defaultimg {
  display: block;
}
.hoverimg {
  display: none;
}
.moreimg:hover .defaultimg {
  display: none;
}
.moreimg:hover .hoverimg {
  display: block;
}

.moretwo {
  width: 100%;
  margin-bottom: 0.2rem;
  margin-top: 0.2rem;
  height: 0.8rem;
}
.moreimgtwo img {
  height: 0.86rem;
}
.moreimgtwo {
  width: 2.4rem;
  height: 0.86rem;
}
.defaultimgtwo {
  display: block;
}
.hoverimgtwo {
  display: none;
}
.moreimgtwo:hover .defaultimgtwo {
  display: none;
}
.moreimgtwo:hover .hoverimgtwo {
  display: block;
}
.clickimg {
  display: none;
}

@media (max-width: 992px) {
  .jobitemain {
    width: 100%;
    height: 100px;
    border: 2px solid black;
    margin-bottom: 0.4rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    position: relative;
    display: inline-block;
    transform: rotateZ(0deg);
    transition: all 500ms;
    overflow: hidden;
    display: block;
    background-color: transparent;
  }

  .itemtitle {
    line-height: 100px;
    font-size: 40px;
    /* margin-left: 0.5rem; */
  }

  .righticon {
    position: absolute;
    right: 19px;
    top: 19px;
    width: 50px;
    height: 50px;
    line-height: 50px;
    display: block;
    font-size: 50px;
  }
  .detailjobtitle {
    font-size: 40px;
  }
  .content {
    font-size: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/job-item.vue